module.exports = __webpack_public_path__ + "static/media/mem7.85b0d70e.jpg";